import { render, staticRenderFns } from "./TaxonomiesMenu.vue?vue&type=template&id=6a79cd05&scoped=true"
import script from "./TaxonomiesMenu.vue?vue&type=script&lang=js"
export * from "./TaxonomiesMenu.vue?vue&type=script&lang=js"
import style0 from "./TaxonomiesMenu.vue?vue&type=style&index=0&id=6a79cd05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a79cd05",
  null
  
)

export default component.exports